import { OnyxScheduleCompliance } from '@onyx/angular';

export class ScheduleComplianceHelper {
  public static getColor(compliance: OnyxScheduleCompliance) {
    switch (compliance) {
      case OnyxScheduleCompliance.ON_TIME:
        return 'green';
      case OnyxScheduleCompliance.DELAY_RISK:
        return 'orange';
      case OnyxScheduleCompliance.DELAYED:
        return 'red';
    }
  }
}
